import { render, staticRenderFns } from "./company-detail.vue?vue&type=template&id=75560550&scoped=true&"
import script from "./company-detail.vue?vue&type=script&lang=js&"
export * from "./company-detail.vue?vue&type=script&lang=js&"
import style0 from "./company-detail.vue?vue&type=style&index=0&id=75560550&prod&lang=css&"
import style1 from "./company-detail.vue?vue&type=style&index=1&id=75560550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75560550",
  null
  
)

export default component.exports